import { Controller } from "@hotwired/stimulus"

// Color readout — usado APENAS na showcase (/admin/components, Tokens de cor).
// Lê o valor COMPUTADO de cada swatch e o exibe, sempre em HEXADECIMAL, ao lado
// do nome do token. Reflete o tema atual (light/dark) e a cor primária do
// AppSetting (injetada em runtime).
//
// Qualquer formato de cor (oklch, rgb, hsl…) é normalizado para #RRGGBB usando
// um <canvas>: ao pintar com a cor e ler de volta, o browser devolve sempre rgb.
//
// Pareia targets `swatch` (a faixa colorida) e `value` (onde o valor é escrito),
// na mesma ordem em que aparecem no DOM.
export default class extends Controller {
  static targets = ["swatch", "value"]

  connect() {
    this.ctx = document.createElement("canvas").getContext("2d")
    this.render()
    // Reage à troca de tema (a classe `dark` no <html> muda as CSS vars).
    this.observer = new MutationObserver(() => this.render())
    this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class", "style"] })
  }

  disconnect() {
    this.observer?.disconnect()
  }

  render() {
    this.swatchTargets.forEach((swatch, i) => {
      const out = this.valueTargets[i]
      if (!out) return
      const hex = this._toHex(getComputedStyle(swatch).backgroundColor)
      out.textContent = hex
      out.setAttribute("title", hex)
    })
  }

  // Normaliza QUALQUER cor CSS para #RRGGBB. O canvas resolve oklch/hsl/rgb →
  // rgb ao desenhar; lemos o pixel e formatamos. Cores com alpha < 1 ganham
  // sufixo (ex.: #RRGGBB @ 50%) — raro nos tokens, mas honesto.
  _toHex(color) {
    try {
      this.ctx.clearRect(0, 0, 1, 1)
      this.ctx.fillStyle = "#000"
      this.ctx.fillStyle = color // browser parseia oklch/rgb/hsl
      this.ctx.fillRect(0, 0, 1, 1)
      const [r, g, b, a] = this.ctx.getImageData(0, 0, 1, 1).data
      const h = (n) => n.toString(16).padStart(2, "0")
      const hex = `#${h(r)}${h(g)}${h(b)}`
      return a < 255 ? `${hex} (${Math.round((a / 255) * 100)}%)` : hex
    } catch {
      return color // fallback: mostra como veio se algo falhar
    }
  }
}
